import { InterruptStateRule } from './interrupt_state_rule';
import { CgsEvent } from '@cgs/wge';
import { SpinResponse } from '@cgs/data-access';
import { BaseGameState } from '../../states/base_game_state';
import { ResponseHolder } from '../../response_holder';
import { SpinEvent } from '../../events/spin_event';

export class SpinRule<TResponse extends SpinResponse> extends InterruptStateRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  eventTest(event: CgsEvent): boolean {
    return event instanceof SpinEvent;
  }

  ruleCondition(_responseHolder: ResponseHolder<TResponse>): boolean {
    return true;
  }
}
